import Server from "../server";
import View from "../framework/view";
import {Order} from "../bo/order";
import template from "../../pugc/list-orders";
import {customFieldsSorter, JsonDate, NOTE_TO_FLORIST} from "../misc/types";
import jQuery from "jquery";
import {format, parseISO} from "date-fns";
import {getDirectionsUrl} from "../misc/orders";

export const calcStateClass = (order: Order) => {
    return order && order.currentStatus ? "status-" + order.currentStatus.replace(/\s/g, "-") : "status-new";
}

export class ListOrdersView extends View {

    static classname = "list-orders-view";

    private readonly server = Server.instance();

    private ids : string[];

    private orders : Order[] = [];

    private selectedIds : { [id: string]: boolean} = {};

    private baseUrl?: string;

    constructor(ids: string[]) {
        super(ListOrdersView.classname);
        this.ids = ids;
        this.refresh();
        this.server.getShortBaseUrl().then((url) => {
            this.baseUrl = url;
            this.update();
        });
    }

    refresh() {
        const q_ = this.server.getOrdersById(this.ids || []);

        q_.then((d) => {

            d = d.filter(x => x);

            const byId : { [id: string]: Order} = {};
            d.forEach((o) => byId[o.id as string] = o);
            this.orders = this.ids.map((id) => byId[id]).filter(x => x);
            this.update();
        });
    }

    protected render0(): JQuery<HTMLElement> {

        if (! this.baseUrl) {
            return jQuery("<div>Loading</div>");
        }

        const toQRCodeUrl = (qrcode_id: string) => `${this.baseUrl}#/qr/${qrcode_id}`;

        // Remove leading Add, trailing colon and capitalise first letter
        const prettyOption = (option: any) => {

            const sel = option.selection;
            if (sel.indexOf("Yes") == 0) {
                const str = option.option.replace(/^Add /, "").replace(/:$/, "");
                return str.charAt(0).toUpperCase() + str.slice(1);
            }

            // remove price
            const cleaned = sel.replace(/\$[0-9]+(\.[0-9]+)?\s*/, "");
            return cleaned;
        }

        const labelDate = (date: JsonDate) => {
            if (! date) {
                return "";
            }
            try {
                const d = parseISO(date);
                const s = format(d, "EEE dd/MM/yyyy");
                return s;
            } catch (err) {
                console.log("Failed to parse date", date, err);
                return date;
            }
        }

        const data = {
            orders: this.orders,
            order_ids: this.ids.join(","),
            selected: this.selectedIds,
            customFieldsSorter: customFieldsSorter,
            NOTE_TO_FLORIST: NOTE_TO_FLORIST,
            prettyOption: prettyOption,
            labelDate: labelDate,
            getDirectionsUrl: getDirectionsUrl,
            calcStateClass: calcStateClass,
        };

        const out = this.pug(template, data);

        return out;
    }

}

